import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';
import './PlayerPieces.scss';

const defaultProps = {
  currentPlayer: null,
};

const PlayerPieces = (p) => {
  const {
    containerIndex,
    players,
    currentPlayer,
    iconHeight,
    pageIndex,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className='player-pieces' data-test='player-pieces'>
      {players.map((player, playerIndex) => (
        player.currentCardIndex === containerIndex ? (
          <img
            key={`player-pieces-${pageIndex}-${containerIndex}-${playerIndex}`}
            id={player.elementId}
            className={`piece-icon ${playerIndex !== currentPlayer ? 'inactive-player' : ''}`}
            src={player.playerPieceImage}
            alt='Piece'
            style={{ height: iconHeight }}
          />
        ) : ''
      ))}
    </div>
  );
};

export default PlayerPieces;
